import React from 'react';

class HomeBanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, // Assuming no loading state as we're receiving props directly
        };
    }

    render() {
        // const { welcomeMessage = "WELCOME TO THEMosque", bannerTitle = "Purity Comes From Faith", buttonText = "Read More", buttonUrl = "/", bgImage = "/img/hero.jpg" } = this.props; // Get data from props
        return (
            <div className="container-fluid  lqe_hero_header"> {/* style={{ backgroundImage: `url(http://localhost:9799/uploads/1746685345606-LQE_video-1.mp4)` }} */}
                 <video autoPlay loop muted playsInline className='video-background'>
                    {/* <source src="./img/Lqe-Img/Video_2.mp4" type="video/mp4" /> */}
                    <source src="https://lqe-assets.learnquraneasily.in/1748088660624_hero_video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                
                {/* <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="hero-header-inner animated zoomIn">
                                
                                {!welcomeMessage || !bannerTitle ? (
                                    <p>Loading...</p> 
                                ) : (
                                    <>
                                        <p className="fs-4 text-dark">{welcomeMessage}</p>
                                        <h1 className="display-1 mb-5 text-dark">{bannerTitle}</h1>
                                        <Link to={buttonUrl} className="btn btn-primary py-3 px-5">
                                            {buttonText}
                                        </Link>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default HomeBanner;
